import React from 'react';

import TimePicker from '@atlaskit/datetime-picker/time-picker';
import Field from '@atlaskit/form/field';

const TimePickerRequiredExample = (): React.JSX.Element => (
	<Field
		name="time"
		label="Start Time"
		isRequired
		component={({ fieldProps: { ...rest } }) => (
			<TimePicker clearControlLabel="Clear start time" {...rest} shouldShowTimeButton />
		)}
	/>
);

export default TimePickerRequiredExample;
